import { render, staticRenderFns } from "./plan_edit.vue?vue&type=template&id=87eb62fa&scoped=true"
import script from "./plan_edit.vue?vue&type=script&lang=js"
export * from "./plan_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87eb62fa",
  null
  
)

export default component.exports